module.exports = __webpack_public_path__ + "img/file---------1@1x.75a395f7.png";